<ng-template #modalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
  </div>
  <div class="modal-body box-parent">
    <div class="row">
      <div class="col">
        <div class="form-label-group">
          <input type="text" id="un" class="form-control" [(ngModel)]="user.username" placeholder="{{'PROFILE.LIST.FILTER.USERNAME' | translate}}">
          <label for="un">{{'PROFILE.LIST.FILTER.USERNAME' | translate}}</label>
        </div>
        <div class="form-label-group">
          <input type="password" id="pw" class="form-control"  [(ngModel)]="user.password" [placeholder]="passwordPlaceHolder" autocomplete="new-password">
          <label for="pw">{{'PROFILE.LIST.FILTER.PASSWORD' | translate}}</label>
          <p class="text-warning">
            - {{ 'PROFILE.PASSWORD.POLICY.NOT_SIMILAR' | translate }}<br>
            - {{ 'PROFILE.PASSWORD.POLICY.LENGTH' | translate }}<br>
            - {{ 'PROFILE.PASSWORD.POLICY.CHARACTERS' | translate }}<br>
            - {{ 'PROFILE.PASSWORD.POLICY.NOT_MATCH_LAST_PASSWORD' | translate }}
          </p>
        </div>
        <div class="dropdown-label-group">
          <p-dropdown
            class="dv-dropdown"
            selectId="group"
            [options]="groups"
            [(ngModel)]="user.group"
            [autoDisplayFirst]="false"
            placeholder="{{'HISTORY.ROLE' | translate}}"
          >
          </p-dropdown>
          <label for="group">{{'HISTORY.ROLE' | translate}}</label>
        </div>

        <div class="multiSelect-label-group">
          <label for="companygroups">{{'PROFILE.LIST.MODAL.COMPANY-ACCESS' | translate}}</label>
          <p-multiSelect
            class="dv-multiSelect"
            selectId="companygroups"
            [options]="companygroups"
            [(ngModel)]="companyGroupID"
            defaultLabel="{{'PROFILE.LIST.FILTER.COMPANY' | translate}}"
            >
          </p-multiSelect>
        </div>

        <div class="multiSelect-label-group">
          <label>{{'PROFILE.LIST.MODAL.DEPARTMENT-ACCESS' | translate}}</label>
          <p-multiSelect
            class="dv-multiSelect"
            selectId="department"
            [options]="department"
            [(ngModel)]="departmentID"
            defaultLabel="{{'PROFILE.LIST.FILTER.DEPARTMENT' | translate}}"
            >
          </p-multiSelect>
        </div>

        <div>
          <div *ngIf="user.is_active && checkUser" style="display: flex; align-items: center;">
              <div style="padding-left:12px; flex-grow: 1;"> {{'PROFILE.LIST.MODAL.CURRENT-STATUS' | translate}}: {{'PROFILE.LIST.TABLE.STATUS.ACTIVE' | translate}} </div>
            <button class="col-auto btn btn-dv" (click)="disableUser()">{{'PROFILE.LIST.MODAL.DEACTIVATE' | translate}}</button>
          </div>
          <div *ngIf="!user.is_active && checkUser" style="display: flex; align-items: center;">
             <div style="padding-left:12px; flex-grow: 1;"> {{'PROFILE.LIST.MODAL.CURRENT-STATUS' | translate}}: {{'PROFILE.LIST.TABLE.STATUS.INACTIVE' | translate}} </div>
            <button class="col-auto btn btn-dv btn-clean btn-wide" (click)="enableUser()">{{'PROFILE.LIST.MODAL.ACTIVATE' | translate}}</button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer m-b-0">
      <div class="col">
        <div class="row m-b-5">
          <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
        </div>
        <div class="row justify-content-center">
          <div class="col">
            <button class="btn btn-dv btn-clean btn-wide m-r-20" (click)="modalRef.hide()">{{'COMMON.CANCEL' | translate}}</button>
          </div>
          <button class="col-auto btn btn-dv btn-wide pull-right" (click)="submit()">{{ createMode ? ('PROFILE.PASSWORD.CONFIRM' | translate) : ('PROFILE.LIST.MODAL.SAVE' | translate) }}</button>
        </div>
      </div>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-list-detail/profile-list-detail.component.html